import { trackEvent } from '@opendoor/shared-fe/build/analytics';
import { EventTrackingAction } from '@opendoor/shared-fe/build/declarations/EventTracking';

const CATEGORY = 'partnership-dashboard';

export default (action: EventTrackingAction, label: string, extra: any = {}) =>
  trackEvent.apply(null, [CATEGORY, action, label, extra]);
